import NotFound from "common/NotFound";
import useFullPageLoader from "common/UseFullPageLoader";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { prescriptionDetailsApi } from "services/prescription-management";
import "./prescription-scss.scss";
import AddPrescription from "./AddPrescription";
import CancelPrescription from "./CancelPrescription";
import ApprovedMedicines from "../user-management/section/approveMedicine/ApprovedMedicines";
import ReactImageMagnify from "react-image-magnify";
import { IoChevronBack } from "react-icons/io5";

const PrescriptionDetails = () => {
  const { userId } = useParams();
  console.log("userId:------->", userId);

  const [loader, onShow, onHide] = useFullPageLoader();
  const [addPrescriptionInstance, setAddPrescriptionInstance] = useState(false);
  const [cancelPrescriptionInstance, setCancelPrescriptionInstance] =
    useState(false);

  const [detailsData, setDetailsData] = useState({});

  const fetchSelectedPrescriptionDetail = async (userId) => {
    try {
      onShow();

      const {
        data: { status, data, code },
      } = await prescriptionDetailsApi(userId);

      if (status || code === 200) {
        setDetailsData(data);
      }
    } catch (error) {
      console.log("error: fetchSelectedPrescriptionDetail", error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchSelectedPrescriptionDetail(userId);
  }, []);

  const closeModel = () => {
    setAddPrescriptionInstance(false);
    setCancelPrescriptionInstance(false);
  };

  //===============download image function========================
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = detailsData?.image?.[0];
    link.download = `prescription-${detailsData?.prescriptionId}.jpg`;
    link.target = "_blank";
    link.click();
  };

  return (
    <div className="prescriptionDetails-container">
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Prescription Management</span>
          &nbsp;
          <span>/ Prescription Detail </span>
        </p>
      </div>

      <div className="card">
        {/* ---details Container */}
        {Object.keys(detailsData).length > 0 ? (
          <>
            <div className="details-container">
              <div className="left-side">
                <h3>#{detailsData?.prescriptionId}</h3>
                {detailsData?.image.length > 0 && (
                  <div className="product_image">
                    <img
                      src={detailsData?.image[0]}
                      alt="prescription"
                      className="smallImage"
                    />
                    {/* <button> Download </button> */}

                    <button
                      style={{
                        backgroundColor: "#774DA9",
                        color: "#fff",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        marginTop: "12px",
                      }}
                      onClick={() => handleDownload(detailsData?.image[0])}
                    >
                      Download
                    </button>
                    {/* <div className="large_image">
                    <div className="magnify_wrapper">

                      <ReactImageMagnify
                        style={{ zIndex: 1000 }}
                        {...{
                          smallImage: {
                            alt: "Wristwatch by Ted Baker London",
                            isFluidWidth: true,
                            src: detailsData?.image[0]
                          },
                          largeImage: {
                            src: detailsData?.image[0],
                            width: 800,
                            height: 800,
                          },
                          shouldUsePositiveSpaceLens: true,
                        }}
                        imageClassName={"smallImage"}
                        enlargedImageClassName={"largeImage"}
                      />
                    </div>
                  </div> */}
                  </div>
                )}

                {/* -------button container */}
                {detailsData?.status === "PENDING" && (
                  <div style={{ marginTop: "1rem" }} className="button_wrap">
                    <button
                      type="button"
                      className="button"
                      onClick={() => {
                        setAddPrescriptionInstance(true);
                      }}
                    >
                      Approve
                    </button>
                    <button
                      type="button button-danger"
                      className="button warning"
                      onClick={() => {
                        setCancelPrescriptionInstance(true);
                      }}
                    >
                      Reject
                    </button>
                  </div>
                )}
              </div>
              <div className="right-side">
                {detailsData?.days && (
                  <div className="days-container">
                    <h4>Number of Days</h4>
                    <p className="days-in-number">{detailsData?.days} Days</p>
                  </div>
                )}

                {detailsData?.description && (
                  <div className="prescription-details-container">
                    <h4>Prescription Details</h4>
                    <p className="description">{detailsData?.description}</p>
                  </div>
                )}

                {detailsData?.rejectionReason && (
                  <div className="prescription-details-container">
                    <h4>Cancel Reason</h4>
                    <p className="description">
                      {detailsData?.rejectionReason}
                    </p>
                  </div>
                )}

                <div className="prescription-details-container">
                  <h4>Status</h4>
                  <p className="description">{detailsData?.status}</p>
                </div>
                <div className="prescription-details-container">
                  <h4>Type</h4>
                  <p className="description">{detailsData?.type}</p>
                </div>
                <div className="prescription-details-container">
                  <h4>Phone Number</h4>
                  <p className="description">
                    {detailsData?.user?.countryCode}-{detailsData?.user?.phone}
                  </p>
                </div>
              </div>
            </div>

            {detailsData?.user?._id && (
              <div className="mt-4">
                <ApprovedMedicines userId={detailsData.user._id} />
              </div>
            )}
          </>
        ) : (
          <NotFound cols={7} msg={"Brand data not found"} onHide={onHide} />
        )}
      </div>

      {addPrescriptionInstance && (
        <AddPrescription
          addPrescriptionInstance={addPrescriptionInstance}
          selectedPrescriptionDetail={detailsData}
          closeModel={closeModel}
        />
      )}

      {cancelPrescriptionInstance && (
        <CancelPrescription
          closeModel={closeModel}
          cancelPrescriptionInstance={cancelPrescriptionInstance}
          detailsData={detailsData}
        />
      )}
    </div>
  );
};

export default PrescriptionDetails;
